export const pathArray = [
  "details",
  "system_Check",
  "authentication",
  "environment",
  "instruction",
  "agreement",
];

export const capitalizeFletter = (string) => {
  return string[0].toUpperCase() + string.slice(1).replace("_", " ");
};

export const envInstructions = [
  "Move to a noise free environment",
  "Close all other personal browser tabs",
  "your facemust be visible, ensure you’re in a well lightened environment",
];
export const instructions = [
  "Your webcam would be used to send videos and snapshots",
  "Your computer’s microphone would record audio from your environment.",
  "Your PC and browser activities will be checked throughout the course of the exam.",
  "Any external devices outside the gadget been used for the exam be put off.",
  "Any external devices outside the gadget been used for the exam be put off.",
  "Voilation of rules woud lead to flags and consequences.",
];

export const aggreements = [
  "Your webcam would be used to send videos and snapshots",
  "Your computer’s microphone would record audio from your environment.",
  "Your PC and browser activities will be checked throughout the course of the exam.",
  "Any external devices outside the gadget been used for the exam be put off.",
  "Any external devices outside the gadget been used for the exam be put off.",
  "Voilation of rules woud lead to flags and consequences.",
];

export const formatToHrsMins = (ms) => {
  if (ms < 0) ms = -ms;
  const time = {
    hour: Math.floor(ms / 3600000) % 24,
    minute: Math.floor(ms / 60000) % 60,
  };
  return Object.entries(time)
    .filter((val) => val[1] !== 0)
    .map(([key, val]) => `${val} ${key}${val !== 1 ? "s" : ""}`)
    .join(" ");
};

export function convertToTimeString(ms) {
  var sec_num = parseInt(ms) / 1000; // don't forget the second param
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);
  var seconds = sec_num - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return hours + ":" + minutes + ":" + seconds;
}

export const formatToHrs = (ms) => {
  if (ms < 0) ms = -ms;
  const time = {
    hour: Math.floor(ms / 3600000) % 24,
  };
  return Object.entries(time)
    .filter((val) => val[1] !== 0)
    .map(([key, val]) => `${val} ${key}${val !== 1 ? "s" : ""}`)
    .join(" ");
};

export const getExpiryTime = (duration) => {
  const time = new Date();
  time.setSeconds(time.getSeconds() + duration / 1000);
  return time;
};

export function generateRandom(min, max) {
  // find diff
  let difference = max - min;

  // generate random number
  let rand = Math.random();

  // multiply with difference
  rand = Math.floor(rand * difference);

  // add with min value
  rand = rand + min;

  return rand;
}

export const VIDEO_SIZE = {
  "640 X 480": { width: 640, height: 480 },
  "640 X 360": { width: 640, height: 360 },
  "480 X 360": { width: 480, height: 360 },
  "360 X 270": { width: 360, height: 270 },
};
